import { memo, useEffect, useState } from 'react';

import { Input } from '@/shadcn/input';

import type { TableFilterProps } from '@/components/ui/table/filters/filters.type';

const DEBOUNCE_TIME = 1500;

// text filter
export const TextFilter = memo(
  ({ colConfig, setColumnFilter, filterConfig }: TableFilterProps<'text'>) => {
    // get current filter string value
    const filterStr = colConfig.filter ? colConfig.filter.value : '';

    const [inputStr, setInputStr] = useState<Maybe<string>>(filterStr);

    // debounce update of the column filter
    useEffect(() => {
      if (inputStr === filterStr) return;

      const handler = setTimeout(() => {
        setColumnFilter(
          colConfig.key,
          inputStr === '' ? undefined : inputStr,
          filterConfig
        );
      }, DEBOUNCE_TIME);

      return () => {
        clearTimeout(handler);
      };
    }, [inputStr]);

    return (
      <Input
        className="h-9 w-full bg-card text-muted-foreground dark:bg-card"
        data-cy={`table-filter-text-${colConfig.key}`}
        id={filterConfig.path}
        onChange={e => setInputStr(e.target.value)}
        placeholder={filterConfig.placeholder || 'Search'}
        type="search"
        value={inputStr}
      />
    );
  }
);
